import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { JobMemberResponse } from '@doda/api-client/aspida/@types';
import { ArrowLeft, ArrowRight, BasicModal } from '@doda/io-react/common';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import styles from './index.module.scss';
import { MemberCard } from './MemberCard';

export const DUMMY_IMAGE = '/DodaFront/Html/images/img_recruiter_001.png';

/**
 * MembersModalのProps
 */
interface MembersModalProps {
  /* 一緒に働くメンバー */
  members: JobMemberResponse[];
  /* モーダルを閉じる処理 */
  onClose: () => void;
  /* 初期表示時のメンバーID */
  initialMemberId: string;
}

/**
 * 求人詳細 募集要項タブ 一緒に働くメンバーを押下して開くモーダル
 */
export const MembersModal: React.FC<MembersModalProps> = ({
  members,
  onClose,
  initialMemberId,
}) => {
  const sliderRef = useRef<Slider | null>(null);

  useEffect(() => {
    if (sliderRef) {
      // 初期表示スライドを設定する
      const inititalSlideIndex =
        members?.findIndex((member) => member.id === initialMemberId) ?? 0;
      sliderRef.current?.slickGoTo(inititalSlideIndex, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialMemberId]);

  return (
    <BasicModal
      title="一緒に働くメンバー"
      width={450}
      show
      onClickClose={onClose}
      className={styles['jobSearchDetail-membersModal']}
    >
      <div className={styles['jobSearchDetail-membersModal__container']}>
        <Slider
          ref={sliderRef}
          centerMode
          infinite
          adaptiveHeight
          centerPadding="0px"
          nextArrow={<Navigation position="right" />}
          prevArrow={<Navigation position="left" />}
        >
          {members.map((member) => {
            // eslint-disable-next-line react/jsx-props-no-spreading
            return <MemberCard key={member.id} {...member} />;
          })}
        </Slider>
      </div>
    </BasicModal>
  );
};

/**
 * NavigationProps
 */
interface NavigationProps {
  /** Navigationをクリックした時の処理 */
  onClick?: () => void;
  /** Navigationの位置 */
  position: 'left' | 'right';
}

/** スライダー送りナビゲーション */
const Navigation: React.FC<NavigationProps> = ({
  onClick,
  position = 'left',
}) => {
  return (
    <button
      type="button"
      className={classNames(styles['jobSearchDetail-membersModal__arrow'], {
        [styles['jobSearchDetail-membersModal__arrow--left']]:
          position === 'left',
        [styles['jobSearchDetail-membersModal__arrow--right']]:
          position === 'right',
      })}
      onClick={onClick}
    >
      {position === 'left' ? (
        <ArrowLeft size="XS" color="black" />
      ) : (
        <ArrowRight size="XS" color="black" />
      )}
    </button>
  );
};
